import React, {Component} from "react";

import {connect} from "react-redux";
import {hideRightSidebar} from "../../store/actions";
//SimpleBar
import SimpleBar from "simplebar-react";

import {Link} from "react-router-dom";

import "./rightbar.scss";
import {Modal, ModalBody, ModalHeader, Table} from "reactstrap";
import {formatUsd} from "../../helpers/Util";
import BigNumber from "bignumber.js";
import Label from "reactstrap/es/Label";
import {removeFromCart} from "../../store/cart/actions";
import ProductCheckout from "../../pages/Product/ProductCheckout";

class RightSidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            checkoutModal: false
        };
        this.hideRightbar = this.hideRightbar.bind(this);
        this.toggleCheckoutModal = this.toggleCheckoutModal.bind(this);
    }

    /**
     * Hides the right sidebar
     */
    hideRightbar(e) {
        e.preventDefault();
        this.props.hideRightSidebar();
    }

    toggleCheckoutModal = () => {
        this.setState(prevState => ({
            checkoutModal: !prevState.checkoutModal
        }));
    };

    render() {
        return (
            <React.Fragment>
                <div className="right-bar">
                    <SimpleBar className="h-100">
                        <div className="p-3">
                            <div className="rightbar-title mb-4">
                                <Link to="#" onClick={this.hideRightbar} className="right-bar-toggle float-right">
                                    <i className="mdi mdi-close noti-icon"/>
                                </Link>
                                <h5 className="pt-1">Cart</h5>
                            </div>
                            <hr/>
                            {this.props.items.length === 0 && <div>
                                <h6 className="text-danger mb-4">The cart is empty.</h6>
                                <a href="/products" className="btn btn-primary btn-block">
                                    <i className="bx bx-customize mr-1"/> Shop Products
                                </a>
                            </div>}
                            {this.props.items.length > 0 && <div>
                                <Table className="table-condensed table-borderless mb-3">
                                    <tbody>
                                    <tr>
                                        <td><b>Items</b></td>
                                        <td>{this.props.items.length}</td>
                                    </tr>
                                    <tr>
                                        <td><b>Subtotal</b></td>
                                        <td>{formatUsd(BigNumber.sum(...this.props.items.map(ci => ci.invest)).toNumber())}</td>
                                    </tr>
                                    </tbody>
                                </Table>
                                <Link to="#" onClick={event => {
                                    this.hideRightbar(event);
                                    this.toggleCheckoutModal();
                                }} className="btn btn-primary btn-block">
                                    <i className="mdi mdi-cart mr-1"/> Checkout
                                </Link>
                                <hr/>
                                <Label>Cart Items:</Label>
                                <Table className="table-condensed">
                                    <tbody>
                                    {this.props.items.map((ci, idx) => <tr key={"cart-" + idx}>
                                        <td>{ci.product.title}</td>
                                        <td>{formatUsd(ci.invest)}
                                            <br/>
                                            <Link className="text-danger" to="#"
                                                  onClick={() => this.props.removeFromCart(ci.product)}>Delete</Link>
                                        </td>
                                    </tr>)}
                                    </tbody>
                                </Table>
                            </div>}
                        </div>
                    </SimpleBar>
                </div>
                <div className="rightbar-overlay"/>
                <Modal isOpen={this.state.checkoutModal} role="dialog" size="xl" autoFocus={true}
                       centered={true} id="checkoutModal">
                    <div className="modal-content">
                        <ModalHeader toggle={() => this.toggleCheckoutModal()}>
                            Checkout
                        </ModalHeader>
                        <ModalBody>
                            <ProductCheckout toggle={this.toggleCheckoutModal}/>
                        </ModalBody>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    const {items} = state.Cart;
    return {items};
};

export default connect(mapStateToProps, {
    hideRightSidebar,
    removeFromCart
})(RightSidebar);
